import { fetchGaz, fetchTubeGazDiametreSuperieur } from '@batical/data/src'
import { I00DIMLIGNEGAZ_State } from '@batical/types/src'

import { debitNormaux, debitGazReel } from '../CommonFormula'

function I00DIMLIGNEGAZ_docalcul(state: I00DIMLIGNEGAZ_State) {
  state = I00DIMLIGNEGAZ_resetChaudiere(state, state.in_nombreChaudiere)
  const selectedGaz = fetchGaz(state.gaz_uuid)
  state.res_sectionPrincipale4 = 'Ø'
  state.res_sectionSecondaire4 = 'Ø'
  state.res_sectionPrincipale3 = 'Ø'
  state.res_sectionSecondaire3 = 'Ø'
  state.res_sectionPrincipale2 = 'Ø'
  state.res_sectionSecondaire2 = 'Ø'
  state.res_sectionPrincipale1 = 'Ø'
  state.res_sectionSecondaire1 = 'Ø'
  state.res_volumeBouteille = 0
  if (selectedGaz) {
    const longeurTotalCh1 = state.in_longeurReseauPrincipal1 + state.in_nombreAccident1
    const longeurTotalCh2 =
      state.in_nombreChaudiere > 0 ? state.in_longeurReseauPrincipal1 + state.in_longeurReseauPrincipal2 + state.in_nombreAccident2 : 0
    const longeurTotalCh3 =
      state.in_nombreChaudiere > 1
        ? state.in_longeurReseauPrincipal1 + state.in_longeurReseauPrincipal2 + state.in_longeurReseauPrincipal3 + state.in_nombreAccident3
        : 0
    const longeurTotalCh4 =
      state.in_nombreChaudiere > 2
        ? state.in_longeurReseauPrincipal1 +
          state.in_longeurReseauPrincipal2 +
          state.in_longeurReseauPrincipal3 +
          state.in_longeurReseauPrincipal4 +
          state.in_nombreAccident4
        : 0
    const longeurPrincinpaleTotalAccident = longeurTotalCh1 + longeurTotalCh2 + longeurTotalCh3 + longeurTotalCh4

    var maxLongeurBranche = state.in_longeurBranche1
    switch (state.in_nombreChaudiere) {
      case 1:
        maxLongeurBranche = Math.max(state.in_longeurBranche1, state.in_longeurBranche2)
        break
      case 2:
        maxLongeurBranche = Math.max(state.in_longeurBranche1, state.in_longeurBranche2, state.in_longeurBranche3)
        break
      case 3:
        maxLongeurBranche = Math.max(state.in_longeurBranche1, state.in_longeurBranche2, state.in_longeurBranche3, state.in_longeurBranche4)
        break
      default:
        break
    }

    // 	  //M10 cell in calcul sheet V1 29/03/2016
    const maxLongeurPrincipaleAccidentBranche = longeurPrincinpaleTotalAccident + maxLongeurBranche

    // 	  //MARK: chaudiere princiaple
    var sommePuissance = state.in_puissanceChaudiere1
    if (state.in_nombreChaudiere > 0) {
      sommePuissance += state.in_puissanceChaudiere2
    }
    if (state.in_nombreChaudiere > 1) {
      sommePuissance += state.in_puissanceChaudiere3
    }
    if (state.in_nombreChaudiere > 2) {
      sommePuissance += state.in_puissanceChaudiere4
    }
    var debitTheorique = debitNormaux(sommePuissance, state.in_pci)
    var debitReel = debitGazReel(state.in_pressionAtmospherique, state.in_pressionGaz, state.in_temperatureGaz, debitTheorique)
    state.res_volumeBouteille = state.in_pressionGaz < 50 ? debitReel : debitReel * 2

    const dn1 = calculDN(state, sommePuissance, longeurTotalCh1, selectedGaz.densite_fictive, maxLongeurPrincipaleAccidentBranche)
    const tube1 = fetchTubeGazDiametreSuperieur(dn1, state.in_gazMaterialIndex)

    if (tube1 != null) {
      state.res_sectionPrincipale1 = tube1.name
      const dnBranche1 = calculDN(
        state,
        state.in_puissanceChaudiere1,
        state.in_longeurBranche1,
        selectedGaz.densite_fictive,
        maxLongeurPrincipaleAccidentBranche
      )
      const tube1Sec = fetchTubeGazDiametreSuperieur(dnBranche1, state.in_gazMaterialIndex)
      if (tube1Sec != null) {
        state.res_sectionSecondaire1 = tube1Sec.name
        state.res_volumeBouteille -= (state.in_longeurBranche1 * Math.pow(tube1Sec.diamInt / 2, 2) * Math.PI) / 1000
      } else {
        state.res_sectionSecondaire1 = 'Ø'
      }
      state.res_volumeBouteille -= (state.in_longeurReseauPrincipal1 * Math.pow(tube1.diamInt / 2, 2) * Math.PI) / 1000

      /**********************************
       *
       * CHAUDIERE 2
       *
       **********************************/
      if (state.in_nombreChaudiere > 0) {
        var dn2 = dn1
        if (state.in_typeCalcul === 1) {
          dn2 = calculDN(
            state,
            sommePuissance - state.in_puissanceChaudiere1,
            longeurTotalCh2,
            selectedGaz.densite_fictive,
            maxLongeurPrincipaleAccidentBranche
          )
        }

        const tube2 = fetchTubeGazDiametreSuperieur(dn2, state.in_gazMaterialIndex)
        if (tube2 != null) {
          state.res_sectionPrincipale2 = tube2.name
          const dnBranche2 = calculDN(
            state,
            state.in_puissanceChaudiere2,
            state.in_longeurBranche2,
            selectedGaz.densite_fictive,
            maxLongeurPrincipaleAccidentBranche
          )
          const tube2Sec = fetchTubeGazDiametreSuperieur(dnBranche2, state.in_gazMaterialIndex)
          state.res_sectionSecondaire2 = 'Ø'
          if (tube2Sec != null) {
            state.res_sectionSecondaire2 = tube2Sec.name
            state.res_volumeBouteille -= (state.in_longeurBranche2 * Math.pow(tube2Sec.diamInt / 2, 2) * Math.PI) / 1000
          }
          state.res_volumeBouteille -= (state.in_longeurReseauPrincipal2 * Math.pow(tube2.diamInt / 2, 2) * Math.PI) / 1000
          /**********************************
           *
           * CHAUDIERE 3
           *
           **********************************/
          if (state.in_nombreChaudiere > 1) {
            var dn3 = dn1
            if (state.in_typeCalcul === 1) {
              dn3 = calculDN(
                state,
                sommePuissance - state.in_puissanceChaudiere1 - state.in_puissanceChaudiere2,
                longeurTotalCh3,
                selectedGaz.densite_fictive,
                maxLongeurPrincipaleAccidentBranche
              )
            }
            const tube3 = fetchTubeGazDiametreSuperieur(dn3, state.in_gazMaterialIndex)
            if (tube3 != null) {
              state.res_sectionPrincipale3 = tube3.name
              const dnBranche3 = calculDN(
                state,
                state.in_puissanceChaudiere3,
                state.in_longeurBranche3,
                selectedGaz.densite_fictive,
                maxLongeurPrincipaleAccidentBranche
              )
              const tube3Sec = fetchTubeGazDiametreSuperieur(dnBranche3, state.in_gazMaterialIndex)
              state.res_sectionSecondaire3 = 'Ø'
              if (tube3Sec != null) {
                state.res_sectionSecondaire3 = tube3Sec.name
                state.res_volumeBouteille -= (state.in_longeurBranche3 * Math.pow(tube3Sec.diamInt / 2, 2) * Math.PI) / 1000
              }
              state.res_volumeBouteille -= (state.in_longeurReseauPrincipal3 * Math.pow(tube3.diamInt / 2, 2) * Math.PI) / 1000
              /**********************************
               *
               * CHAUDIERE 4
               *
               **********************************/
              if (state.in_nombreChaudiere > 2) {
                var dn4 = dn1
                if (state.in_typeCalcul === 1) {
                  dn4 = calculDN(
                    state,
                    sommePuissance - state.in_puissanceChaudiere1 - state.in_puissanceChaudiere2 - state.in_puissanceChaudiere3,
                    longeurTotalCh4,
                    selectedGaz.densite_fictive,
                    maxLongeurPrincipaleAccidentBranche
                  )
                }

                const tube4 = fetchTubeGazDiametreSuperieur(dn4, state.in_gazMaterialIndex)
                if (tube4 != null) {
                  state.res_sectionPrincipale4 = tube4.name
                  const dnBranche4 = calculDN(
                    state,
                    state.in_puissanceChaudiere4,
                    state.in_longeurBranche4,
                    selectedGaz.densite_fictive,
                    maxLongeurPrincipaleAccidentBranche
                  )
                  const tube4Sec = fetchTubeGazDiametreSuperieur(dnBranche4, state.in_gazMaterialIndex)
                  state.res_sectionSecondaire4 = 'Ø'
                  if (tube4Sec != null) {
                    state.res_sectionSecondaire4 = tube4Sec.name
                    state.res_volumeBouteille -= (state.in_longeurBranche4 * Math.pow(tube4Sec.diamInt / 2, 2) * Math.PI) / 1000
                  }
                  state.res_volumeBouteille -= (state.in_longeurReseauPrincipal4 * Math.pow(tube4.diamInt / 2, 2) * Math.PI) / 1000
                }
              }
            }
          }
        }
      }
    }
    if (state.res_volumeBouteille < 0) {
      state.res_volumeBouteille = 0
    }
  }

  state.invalidated = false
  return state
}

function calculDN(
  state: I00DIMLIGNEGAZ_State,
  puissance: number,
  longeurTotal: number,
  densite_fictive: number,
  maxLongeurPrincipaleAccidentBranche: number
) {
  var debitTheorique = debitNormaux(puissance, state.in_pci)
  var debitReel = debitGazReel(state.in_pressionAtmospherique, state.in_pressionGaz, state.in_temperatureGaz, debitTheorique)
  var pdcMaxi = (state.in_pressionGaz * 0.05 * longeurTotal) / maxLongeurPrincipaleAccidentBranche
  return Math.pow((3.2 * densite_fictive * longeurTotal * Math.pow(debitReel, 1.875)) / (pdcMaxi * 10), 0.2) * 10
}

function I00DIMLIGNEGAZ_resetChaudiere(state: I00DIMLIGNEGAZ_State, numberC: number) {
  if (numberC < 3) {
    state.in_puissanceChaudiere4 = 0
    state.in_longeurReseauPrincipal4 = 0
    state.in_longeurBranche4 = 0
    state.in_nombreAccident4 = 0
    state.res_sectionPrincipale4 = 'Ø'
    state.res_sectionSecondaire4 = 'Ø'
  }
  if (numberC < 2) {
    state.in_puissanceChaudiere3 = 0
    state.in_longeurReseauPrincipal3 = 0
    state.in_longeurBranche3 = 0
    state.in_nombreAccident3 = 0
    state.res_sectionPrincipale3 = 'Ø'
    state.res_sectionSecondaire3 = 'Ø'
  }
  if (numberC < 1) {
    state.in_puissanceChaudiere2 = 0
    state.in_longeurReseauPrincipal2 = 0
    state.in_longeurBranche2 = 0
    state.in_nombreAccident2 = 0
    state.res_sectionPrincipale2 = 'Ø'
    state.res_sectionSecondaire2 = 'Ø'
    state.in_longeurBranche1 = 0
  }
  return state
}

export default I00DIMLIGNEGAZ_docalcul
